import { lazy } from 'react'
import { Navigate, useRoutes } from 'react-router-dom'

import pathName, { DASHBOARD_TXT, NEW_DASHBOARD_TXT } from './pathName.constant'
import ProtectedRoute from './PrivateRoute'
import FirstAid from '../components/firstAid'
import InterventionPortal from '../components/icc/InterventionPortal'
import PageNotFound from '../components/PageNotFound'
import UserManagement from '../components/userManagement/presentation'
import { ANGANWADI_CENTER } from '../routing/pathName.constant'

const ChildrenView = lazy(
  () =>
    import('../components/userManagement/presentation/children/ChildrenView'),
)
const AppLayout = lazy(
  () => import('../components/layout/presentation/AppLayout'),
)
const Auth = lazy(() => import('../components/layout/presentation'))
const AddEditJobs = lazy(
  () => import('../components/jobs/presentation/addJobs'),
)
const Home = lazy(() => import('../components/home/presentation'))
const Dashboard = lazy(() => import('../components/dashboard/presentation'))
const DashboardView = lazy(
  () => import('../components/dashboard/presentation/DashboardView'),
)
const SelectedPhotoDashboard = lazy(
  () => import('../components/dashboard/presentation/SelectedPhotoDashboard'),
)

const AuthAddUser = lazy(
  () => import('../components/userManagement/presentation/AuthAddUser'),
)
const Profile = lazy(() => import('../components/profile/presentation/index'))
const UnassignedAnganwadiCenters = lazy(
  () =>
    import(
      '../components/jobs/presentation/viewJobs/UnassignedAnganwadiCenters'
    ),
)
const JobManagement = lazy(() => import('../components/jobs/presentation'))
const Notifications = lazy(
  () => import('../components/notifications/presentation'),
)
const UpdatedDashboard = lazy(
  () => import('../components/dashboard/presentation/UpdateDashboard'),
)

const Routing = () => {
  const routes = useRoutes([
    {
      path: pathName.ROOT,
      element: (
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Navigate to={pathName.HOME} replace={true} />,
        },
        {
          path: pathName.HOME,
          element: <Home />,
        },
        {
          path: DASHBOARD_TXT,
          index: true,
          element: <Dashboard />,
        },
        {
          path: pathName.DASHBOARD,
          element: <DashboardView />,
        },
        {
          path: NEW_DASHBOARD_TXT,
          element: <UpdatedDashboard />,
        },
        {
          path: pathName.PHOTO_DASHBOARD,
          element: <SelectedPhotoDashboard />,
        },
        {
          path: pathName.USER,
          element: <UserManagement />,
        },
        {
          path: pathName.ADD_USER,
          element: <AuthAddUser />,
        },
        {
          path: pathName.PROFILE,
          element: <Profile />,
        },
        {
          path: pathName.CHILDREN_VIEW,
          element: <ChildrenView />,
        },
        {
          path: pathName.FIRST_AID,
          element: <FirstAid />,
        },
        {
          path: `/${ANGANWADI_CENTER}`,
          element: <UnassignedAnganwadiCenters />,
        },
        {
          path: pathName.JOBS,
          element: <JobManagement />,
        },
        {
          path: pathName.ADD_JOB,
          element: <AddEditJobs />,
        },
        {
          path: pathName.EDIT_JOB,
          element: <AddEditJobs />,
        },
        {
          path: pathName.NOTIFICATIONS,
          element: <Notifications />,
        },
        { path: '*', element: <PageNotFound /> },
      ],
    },
    { path: pathName.LOGIN, element: <Auth /> },
    { path: pathName.FORGOT_PASSWORD, element: <Auth /> },
    { path: pathName.ICC, element: <InterventionPortal /> },
  ])

  return routes
}

export default Routing
